import React, { useEffect, useState } from "react";
import PageTitle from "../../../module/pageTitle";
import AdminTable from "../../../Component/adminTable";
import LabelInput from "../../../Component/labelInput";
import { InputField, Submitbtn } from "../../../Component";
import DropDown from "../../../Component/dropdown";
import AddMoreBtn from "../../../Component/addMoreBtn";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { getSubCategoryList } from "../adminSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
const EditDeleteSubCategory = () => {
  const initialVal = [
    {
      name: "",
      order: "",
    },
  ];
  const dispatch = useDispatch<AppDispatch>();
  const [subCategoryArr, setSubCategoryArr] = useState<any>(initialVal);
  const [isEditMode, setisEditMode] = useState<Boolean>(false);
  const [subCategoryList, setSubCategoryList] = useState<any>([]);

  useEffect(() => {
    dispatch(
      getSubCategoryList({
        callback: (res: any) => {
          setSubCategoryList(res?.data);
        },
        errorCallback: () => {},
      })
    );
  }, []);

  const onPressAdd = () => {
    setSubCategoryArr([...subCategoryArr, initialVal[0]]);
  };
  const handleClose = (index: any) => {
    const newArray = [...subCategoryArr];
    if (index > -1) {
      newArray.splice(index, 1);
    }
    setSubCategoryArr(newArray);
  };
  const handleEdit = (value: any) => {
    // setisEditMode(true);
  };
  const handleDelete = (value: any) => {
    setisEditMode(false);
  };
  const renderTable = () => {
    return (
      <div>
        <AdminTable
          tableData={subCategoryList ? subCategoryList : []}
          pagename={"ProductType"}
          tableHead={["S.N", "Name", "Order No.", "Seo Name", "Action"]}
          handleEdit={(value: any) => handleEdit(value)}
          handleDelete={(value: any) => handleDelete(value)}
          edit={true}
        />
      </div>
    );
  };

  const renderEditMode = () => {
    return (
      <form>
        <div className="row align-items-center">
          <div className="col-md-5 mb-3">
            <LabelInput labelName={"Product Type"} />
            <DropDown
              labelName={"Select Product Type"}
              setInputText={(value: any) => ""}
              options={""}
              value={""}
            />
          </div>
          <div className="col-md-5 mb-3">
            <LabelInput labelName={"Category "} />
            <DropDown
              labelName={"Select Category "}
              setInputText={(value: any) => ""}
              options={""}
              value={""}
            />
          </div>
          {subCategoryArr.map((item: any, index: any) => {
            const { name, order } = item;
            return (
              <div className="col-md-5 mb-4" key={index}>
                <div className="d-flex">
                  <div className="bxshadow p-2 borderRadius w-100">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <LabelInput labelName={"Sub Category Name"} />
                        <InputField
                          key={"ex2"}
                          placeholder={"Enter Sub Category Name"}
                          setInputText={(value: any) => ""}
                          value={name}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <LabelInput labelName={"Order number"} />
                        <InputField
                          key={"ex2"}
                          placeholder={"Enter Order number"}
                          setInputText={(value: any) => ""}
                          value={order}
                        />
                      </div>
                    </div>
                  </div>
                  {subCategoryArr?.length === 1 ? (
                    ""
                  ) : (
                    <DeleteForeverIcon
                      className="text-danger"
                      onClick={() => handleClose(index)}
                    />
                  )}
                </div>
              </div>
            );
          })}
          <div className="col-md-2 pt-5">
            <AddMoreBtn handleClick={onPressAdd} />
          </div>
        </div>
        <div className="col-md-1 mx-auto my-4">
          <Submitbtn name={"Submit"} disabled={false} />
        </div>
      </form>
    );
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle
          name={"Edit / Delete Sub Category"}
          breadCrumb={""}
          isEditMode={isEditMode}
          setisEditMode={setisEditMode}
        />
      </div>
      <div className="formDiv bxshadow">
        <div className=" p-2 borderRadius">
          {isEditMode ? renderEditMode() : renderTable()}
        </div>
      </div>
    </div>
  );
};

export default EditDeleteSubCategory;
